import React, { useEffect, useState } from "react";
import { Icons } from "assets";
import styles from "./style.module.scss";

interface Step {
  id: number;
  label: string;
}

interface MultiStepFormProps {
  steps: Step[];
  currentStep: number;
  showStepNumbers?: boolean;
  children: React.ReactNode;
  onNext?: () => void;
  onPrev?: () => void;
  onSubmit?: () => void;
}

const MultiStepForm = ({
  steps,
  currentStep,
  showStepNumbers = true,
  children,
}: MultiStepFormProps) => {
  const [, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth <= 640);
    };

    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const calculateProgress = () => {
    const progress = ((currentStep - 1) / steps.length) * 100;
    return Math.max(0, Math.min(100, progress));
  };

  const progressPercentage = calculateProgress();

  return (
    <div className={styles.container}>
      <div className={styles.progressSection}>
        <div className={styles.stepsWrapper}>
          <div
            className={styles.stepConnector}
            style={{
              width: `${progressPercentage}%`,
            }}
          />

          {steps.map((step) => {
            const isCompleted = currentStep > step.id;
            const isCurrent = currentStep === step.id;

            return (
              <div key={step.id} className={styles.stepItem}>
                <div
                  className={`${styles.stepCircle} 
          ${isCompleted ? styles.active : ""} 
          ${isCurrent ? styles.initialActive : ""}`}
                >
                  {isCompleted ? (
                    <Icons.TickIcon />
                  ) : showStepNumbers ? (
                    step.id
                  ) : (
                    ""
                  )}
                </div>

                <span
                  className={`${styles.stepLabel} ${
                    isCompleted || isCurrent ? styles.activeLabel : ""
                  }`}
                >
                  {step.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      <div className={styles.contentSection}>{children}</div>
    </div>
  );
};

export default MultiStepForm;
export type { MultiStepFormProps, Step };
